

import LandingPageShell from "@/components/landing-page/layout/LandingPageShell";

export default function CookiePolicyPage() {
  return (
    <LandingPageShell surface="white" className="text-slate-900">
      <div className="mx-auto max-w-4xl px-4 py-12 md:py-16">
        <div className="mb-6">
          <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            <span>Legal · Cookies</span>
          </div>
        </div>

        <div className="rounded-3xl border border-slate-200 bg-white shadow-sm px-5 py-8 md:px-8 md:py-10">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-2">
            How inaraX uses cookies
          </h1>
          <p className="text-xs md:text-sm text-slate-500 mb-8">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="prose prose-slate max-w-none">
          <p>
            This Cookie Policy explains how <strong>inaraX</strong> (&quot;we&quot;,
            &quot;us&quot;, &quot;our&quot;) uses cookies and similar technologies on our
            website and web application.
          </p>

          <h2 className="mt-10 text-xl md:text-2xl font-semibold text-slate-900">
            1. What are cookies?
          </h2>
          <p>
            Cookies are small text files that are stored on your device when you
            visit a website. They help websites remember information about your
            visit, such as your session, preferences, or security state.
          </p>
          <p>
            We use cookies and similar technologies (such as local storage and
            server-side sessions) to:
          </p>
          <ul>
            <li>Keep you signed in securely</li>
            <li>Protect your account and our platform</li>
            <li>Remember basic preferences</li>
            <li>Understand how the product is used so we can improve it</li>
          </ul>
          <p>We do not use cookies to run third-party advertising networks.</p>

          <h2 className="mt-10 text-xl md:text-2xl font-semibold text-slate-900">
            2. Types of cookies we use
          </h2>

          <h3 className="mt-6 text-lg font-semibold text-slate-900">
            a) Strictly necessary cookies
          </h3>
          <p>
            These cookies are required for inaraX to function. Without them,
            core features such as sign-in, secure areas, and CSRF protection
            will not work.
          </p>
          <p>Examples include:</p>
          <ul>
            <li>
              <strong>Authentication and session cookies (Clerk):</strong> used
              to keep you signed in, associate your browser session with your
              user account, and enforce security checks.
            </li>
            <li>
              <strong>Security cookies:</strong> used to help prevent malicious
              activity (for example, CSRF or abuse detection) and to ensure
              requests are coming from valid sessions.
            </li>
          </ul>
          <p>
            These cookies are essential and cannot be turned off in our
            systems, though you can block them in your browser (the app will
            then not work correctly).
          </p>

          <h3 className="mt-6 text-lg font-semibold text-slate-900">
            b) Analytics and performance
          </h3>
          <p>
            We use observability and analytics tooling (such as Application
            Insights or similar) to understand product performance and
            reliability. Depending on configuration, this may use anonymous or
            pseudonymous identifiers to group page views and API requests, along
            with basic technical data (for example, browser type, approximate
            location at region/city level, pages visited, request timings, and
            errors).
          </p>
          <p>We use this information to:</p>
          <ul>
            <li>Monitor uptime and performance</li>
            <li>Debug issues and errors</li>
            <li>Improve user experience and product stability</li>
          </ul>
          <p>
            We do not use this data to build advertising profiles or sell your
            data to third parties.
          </p>

          <h3 className="mt-6 text-lg font-semibold text-slate-900">
            c) Preference and UX-related storage
          </h3>
          <p>
            The inaraX codebase may store certain UI preferences in your
            browser (for example, whether specific banners, menus, or sidebars
            are open or closed). This is typically stored via local storage or
            in-memory state, and is only used to make the interface feel
            smoother and more consistent between visits.
          </p>

          <h2 className="mt-10 text-xl md:text-2xl font-semibold text-slate-900">
            3. Services that set cookies
          </h2>
          <p>
            inaraX integrates with a small number of third-party services that
            may set their own cookies or similar identifiers when you use the
            product:
          </p>
          <ul>
            <li>
              <strong>Clerk (authentication):</strong> handles sign-up,
              sign-in, and user sessions. Clerk sets cookies required to
              authenticate and secure your account.
            </li>
            <li>
              <strong>Analytics/observability provider:</strong> may set its own
              identifiers for error tracking and performance monitoring, as
              described above.
            </li>
          </ul>
          <p>
            These providers process data in accordance with their own privacy
            and cookie policies, in addition to this one.
          </p>

          <h2 className="mt-10 text-xl md:text-2xl font-semibold text-slate-900">
            4. How you can manage cookies
          </h2>
          <p>
            You can control cookies through your browser settings, including the
            ability to:
          </p>
          <ul>
            <li>Block or delete cookies from specific sites</li>
            <li>Clear existing cookies and local storage</li>
            <li>Use private or incognito browsing modes</li>
          </ul>
          <p>
            Please note that if you block or delete essential cookies, you may
            not be able to sign in or use core features of inaraX. Analytics and
            performance data will also be less accurate if you block related
            cookies or storage.
          </p>

          <h2 className="mt-10 text-xl md:text-2xl font-semibold text-slate-900">
            5. Changes to this Cookie Policy
          </h2>
          <p>
            We may update this Cookie Policy from time to time to reflect
            changes in our product, technology, or legal requirements. When we
            do, we will update the &quot;Last updated&quot; date at the top. In
            some cases, we may provide additional notice (for example, an in-app
            banner or email).
          </p>

          <h2 className="mt-10 text-xl md:text-2xl font-semibold text-slate-900">
            6. Contact us
          </h2>
          <p>
            If you have any questions about how inaraX uses cookies, please
            contact us at:
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:team@atomcamparabia.com">team@atomcamparabia.com</a>
          </p>
          </div>
        </div>
      </div>
    </LandingPageShell>
  );
}

